"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.MockContract__factory = void 0;
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        payable: true,
        stateMutability: "payable",
        type: "fallback",
    },
    {
        constant: true,
        inputs: [],
        name: "MOCKS_LIST_END",
        outputs: [
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "MOCKS_LIST_END_HASH",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "MOCKS_LIST_START",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "SENTINEL_ANY_MOCKS",
        outputs: [
            {
                internalType: "bytes4",
                name: "",
                type: "bytes4",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "bytes",
                name: "response",
                type: "bytes",
            },
        ],
        name: "givenAnyReturn",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "bool",
                name: "response",
                type: "bool",
            },
        ],
        name: "givenAnyReturnBool",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "uint256",
                name: "response",
                type: "uint256",
            },
        ],
        name: "givenAnyReturnUint",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "address",
                name: "response",
                type: "address",
            },
        ],
        name: "givenAnyReturnAddress",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [],
        name: "givenAnyRevert",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "string",
                name: "message",
                type: "string",
            },
        ],
        name: "givenAnyRevertWithMessage",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [],
        name: "givenAnyRunOutOfGas",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "bytes",
                name: "call",
                type: "bytes",
            },
            {
                internalType: "bytes",
                name: "response",
                type: "bytes",
            },
        ],
        name: "givenCalldataReturn",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "bytes",
                name: "call",
                type: "bytes",
            },
            {
                internalType: "bool",
                name: "response",
                type: "bool",
            },
        ],
        name: "givenCalldataReturnBool",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "bytes",
                name: "call",
                type: "bytes",
            },
            {
                internalType: "uint256",
                name: "response",
                type: "uint256",
            },
        ],
        name: "givenCalldataReturnUint",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "bytes",
                name: "call",
                type: "bytes",
            },
            {
                internalType: "address",
                name: "response",
                type: "address",
            },
        ],
        name: "givenCalldataReturnAddress",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "bytes",
                name: "call",
                type: "bytes",
            },
            {
                internalType: "bytes",
                name: "response",
                type: "bytes",
            },
        ],
        name: "givenMethodReturn",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "bytes",
                name: "call",
                type: "bytes",
            },
            {
                internalType: "bool",
                name: "response",
                type: "bool",
            },
        ],
        name: "givenMethodReturnBool",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "bytes",
                name: "call",
                type: "bytes",
            },
            {
                internalType: "uint256",
                name: "response",
                type: "uint256",
            },
        ],
        name: "givenMethodReturnUint",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "bytes",
                name: "call",
                type: "bytes",
            },
            {
                internalType: "address",
                name: "response",
                type: "address",
            },
        ],
        name: "givenMethodReturnAddress",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "bytes",
                name: "call",
                type: "bytes",
            },
        ],
        name: "givenCalldataRevert",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "bytes",
                name: "call",
                type: "bytes",
            },
        ],
        name: "givenMethodRevert",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "bytes",
                name: "call",
                type: "bytes",
            },
            {
                internalType: "string",
                name: "message",
                type: "string",
            },
        ],
        name: "givenCalldataRevertWithMessage",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "bytes",
                name: "call",
                type: "bytes",
            },
            {
                internalType: "string",
                name: "message",
                type: "string",
            },
        ],
        name: "givenMethodRevertWithMessage",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "bytes",
                name: "call",
                type: "bytes",
            },
        ],
        name: "givenCalldataRunOutOfGas",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "bytes",
                name: "call",
                type: "bytes",
            },
        ],
        name: "givenMethodRunOutOfGas",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [],
        name: "invocationCount",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "bytes",
                name: "call",
                type: "bytes",
            },
        ],
        name: "invocationCountForMethod",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "bytes",
                name: "call",
                type: "bytes",
            },
        ],
        name: "invocationCountForCalldata",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [],
        name: "reset",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
];
const _bytecode = "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";
class MockContract__factory extends ethers_1.ContractFactory {
    constructor(signer) {
        super(_abi, _bytecode, signer);
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.MockContract__factory = MockContract__factory;
MockContract__factory.bytecode = _bytecode;
MockContract__factory.abi = _abi;
